import React, { useState, useEffect } from 'react';
import { useGlobal } from 'reactn';
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Focuspoint } from 'components/Focuspoint';
import SearchBar from 'components/SearchBar';
import { GoogleMap, MarkerWithInfoWindow, MarkerIconSVG } from 'components/GoogleMap';
import Loader from 'components/Loader';
import { useApi } from 'stores/api';
import { isEmpty, imgUrl } from 'stores/utils';

const google = window.google;

const VIEW_TYPE = {
  LIST_NOMAP: 0,
  TILES_NOMAP: 1,
  LIST_MAP: 2,
  TILES_MAP: 3,
};

// const VIEW_TYPES = [
//   { name: "LIST_NOMAP", class: "nomap list", enabled: false },
//   { name: "TILES_NOMAP", class: "nomap tiles", enabled: false },
//   { name: "LIST_MAP", class: "map list", enabled: false },
//   { name: "TILES_MAP", class: "map tiles", enabled: false },
// ];

const VIEW_TYPE_CONTAINER_CLASS = {
  [VIEW_TYPE.LIST_NOMAP]: "nomap list",
  [VIEW_TYPE.TILES_NOMAP]: "nomap tiles",
  [VIEW_TYPE.LIST_MAP]: "map list",
  [VIEW_TYPE.TILES_MAP]: "map tiles",
}
// function useQuery() {
//todo pra
//if there are query variables, get them and convert them into searchParams and make a search
//     return new URLSearchParams(useLocation().search);
// }

const Search = (props) => {
  //let query = useQuery();
  const { t } = useTranslation(['search']);
  let location = useLocation();
  let history = useHistory();
  const api = useApi();
  const [state, setState] = useState({
    viewTypes: [VIEW_TYPE.TILES_NOMAP],
    viewType: VIEW_TYPE.TILES_MAP,
    viewTypeClass: VIEW_TYPE_CONTAINER_CLASS[VIEW_TYPE.TILES_MAP]
  });
  const [canLoadMore, setCanLoadMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchResults, setSearchResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [masterData] = useGlobal('masterData');
  const [showLoader, setShowLoader] = useGlobal('showLoader');
  const [searchParams, setSearchParams] = useGlobal('searchParams');
  const [searchPageVars, setSearchPageVars] = useGlobal('searchPageVars');
  const [openFilters, setOpenFilters] = useGlobal('openFilters');
  const [markerVars, setMarkerVars] = useGlobal('markerVars');
  const [markerLoc, setMarkerLoc] = useGlobal('markerLoc');
  const [markerLatLng, setMarkerLatLng] = useGlobal('markerLatLng');
  const [searchNow, setSearchNow] = useGlobal('searchNow');
  const [cartCount] = useGlobal('cartCount');
  const [modalProps, setModalProps] = useGlobal('modalProps');
  const [orderId] = useGlobal('orderId');
  const [currentTxnId, setCurrentTxnId] = useGlobal('currentTxnId');
  const [isSameTimePeriod] = useGlobal('isSameTimePeriod');
  const pageSize = 9;

  const setViewTypes = () => {
    let viewTypes = state.viewTypes.slice();
    if (!masterData.organization.HideMap) {
      viewTypes.push(VIEW_TYPE.TILES_MAP);
    }
    if (masterData.organization.ShowListView) {
      viewTypes.push(VIEW_TYPE.LIST_NOMAP);
      if (!masterData.organization.HideMap) {
        viewTypes.push(VIEW_TYPE.LIST_MAP);
      }
    }
    //let viewType = masterData.organization.HideMap ? (masterData.organization.ShowListView ? VIEW_TYPE.LIST_NOMAP : VIEW_TYPE.TILES_NOMAP) : VIEW_TYPE.TILES_MAP;
    let viewType = masterData.organization.ShowListView ? 
      (masterData.organization.HideMap ? VIEW_TYPE.LIST_NOMAP : VIEW_TYPE.LIST_MAP)  : 
      (masterData.organization.HideMap ? VIEW_TYPE.TILES_NOMAP : VIEW_TYPE.TILES_MAP);
    setState({
      viewTypes,
      viewType,
      viewTypeClass: VIEW_TYPE_CONTAINER_CLASS[viewType]
    })
  }

  const onGetSearchResults = (results) => {
    const { Paging } = results;
    const paging = Paging?.[0];
    if (paging) {
      const { PageNumber, TotalResultCount, PageSize } = paging;
      if(TotalResultCount === 0) {
        setModalProps({ ...modalProps, showModal: true, messages: [t("noResults")] });
      }
      if ((PageNumber * PageSize) < TotalResultCount) {
        setCanLoadMore(true);
        setPageNumber(PageNumber);
      } else {
        setCanLoadMore(false);
      }
    }
    setSearchResults(results.RentalObject);

    if(results.RentalParameterFacet && results.RentalParameterFacet.length) {
        let objFacets = {};
        let objFeatureEnums = [];
        let objFeatureRanges = [];
        const objFeatures = api.getObjFeaturesFromRPFacets(results.RentalParameterFacet);
        objFeatureEnums = objFeatures.enums;
        objFeatureRanges = objFeatures.ranges;
        objFacets = objFeatures.facets;
        if (Object.keys(objFacets).length > 0) {
            setOpenFilters(true);
        }                
        setSearchPageVars({
            ...searchPageVars,
            objFeatureEnums,
            objFeatureRanges,
            objFacets
        });
    }

    if (searchParams.businessUnitId) {
      setMarkerLoc(searchParams.businessUnitId);
      let first = searchPageVars.locations["All"].find(item => item.id === searchParams.businessUnitId);
      if (first) {
        setMarkerLatLng({ lat: first.lat, lng: first.lng });
      }
    } else {
      setMarkerLoc(null);
      setMarkerLatLng(null);
    }
    setMarkerVars({ isClicked: false, locationId: null });
    setProcessing(false);
  }

  const onSwitchView = () => {
    let viewIndex = state.viewTypes.findIndex(elem => elem === state.viewType);
    let newIndex = (viewIndex === state.viewTypes.length - 1) ? 0 : (viewIndex + 1);
    let newViewType = state.viewTypes[newIndex];
    setState({
      ...state,
      viewType: newViewType,
      viewTypeClass: VIEW_TYPE_CONTAINER_CLASS[newViewType]
    })
  }

  const onClickBooking = async (e, objectId) => {
    e.preventDefault();
    setCurrentTxnId('');
    if (cartCount && isSameTimePeriod) {
      if(processing) return;
      setProcessing(true);
      const { startDate, endDate } = searchParams;
      let objectDetails = await api.fetchObjectDetails({ objectId, startDate, endDate, onlyExactMatch: true });
      if (objectDetails && objectDetails.objectExceptions && objectDetails.objectExceptions.length > 0) {
        setModalProps({ ...modalProps, showModal: true, messages: objectDetails.objectExceptions.map(ex => ex.Message) });
        setProcessing(false);
      }
      else {
        let exactMatch = masterData.organization.SearchExact;
        let txnId = await api.createTxn(objectId, exactMatch);
        if (txnId) {
          let options = objectDetails.objectOptions;
          const services = options.Services;
          const accessories = options.Accessories;
          if (services.length === 0 && accessories.length === 0) {
            console.log("no options to choose for the given object");
            const result = await api.createOrUpdateOrder(orderId, txnId);
            if (result) {
              history.push('/wizard/overview');
            }
          } else {
            console.log("options available to choose for the given object");
            history.push('/wizard/options/add');
          }
        }
      }
    } else {
      history.push(`/wizard/book/${objectId}`);
    }
  }

  const onClickMarker = (marker) => {
    setMarkerVars({ isClicked: true, locationId: marker.id });
  }

  const onClickShowAll = () => {
    setMarkerVars({ isClicked: true, locationId: null });
  }

  const searchObjects = async () => {
    if (!isEmpty(searchParams) && searchParams.startDate && searchParams.endDate) {
      setShowLoader(true);
      const results = await api.searchObjects(searchParams, 1);
      onGetSearchResults(results);
      setShowLoader(false);
      setSearchNow(false);
    }
  };

  const loadMore = async () => {
    const results = await api.searchObjects(searchParams, pageNumber + 1);

    const { Paging } = results;
    const paging = Paging?.[0];
    if (paging) {
      const { PageNumber, TotalResultCount, PageSize } = paging;
      if ((PageNumber * PageSize) < TotalResultCount) {
        setCanLoadMore(true);
        setPageNumber(PageNumber);
      } else {
        setCanLoadMore(false);
      }
    }
    setSearchResults([...searchResults, ...results.RentalObject]);
    setSearchNow(false);
  }

  useEffect(() => {
    if (!searched && searchPageVars.loaded) {
      searchObjects();
      setSearched(true);
    }
  }, [searchPageVars]);

  useEffect(() => {
    if (searchNow) {
      searchObjects();
    }
  }, [searchNow]);

  useEffect(() => {
    setTimeout(() => {
      window.$('.focuspoint').focusPoint('adjustFocus');
    }, 400);
  }, [state.viewType])

  useEffect(() => {
    setViewTypes();
  }, [])

  if (showLoader) return <Loader />;

  return (
    <div className={`search-results-wrapper ${state.viewTypeClass}`}>
      <SearchBar page="Search" onGetSearchResults={onGetSearchResults} />
      <section className={`search-results-container`}>
        <div className="row">
          <div className="column-5 map-container">
            <div className="row">
              {searchPageVars.showMaps &&
                <GoogleMap
                  containerElement={<div className="column-12" />}
                  mapElement={<div id="map"></div>}
                  {...{
                    zoom: 7,
                    mapTypeControl: false,
                    scrollwheel: false,
                    streetViewControl: false,
                    navigationControl: true,
                    zoomControl: true,
                    panControl: true,
                    zoomControlOptions: {
                      style: google.maps.ZoomControlStyle.SMALL
                    },
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                  }}
                  defaultOptions={{
                    styles: [
                      {
                        stylers: [
                          { visibility: "on" },
                          { saturation: -100 },
                        ]
                      }
                    ]
                  }}
                  defaultCenter={{ lat: 47.44189058, lng: 8.43409091 }}
                  myMarkers={masterData.locations["All"]}
                >
                  {masterData.locations["All"].map(o => {
                    return <MarkerWithInfoWindow
                      key={o.lat + '_' + o.lng}
                      position={{ lat: o.lat, lng: o.lng }}
                      title={o.text}
                      canShow={markerLoc && searchParams.businessUnitId === o.id}
                      onClick={() => { onClickMarker(o) }}
                      icon={{
                        path: MarkerIconSVG,
                        fillColor: (markerLatLng && (markerLatLng.lat === o.lat && markerLatLng.lng === o.lng)) ? masterData.organization.settings.primaryColor || '#000000' : '#FFFFFF',
                        fillOpacity: 1,
                        strokeWeight: 2,
                        size: new google.maps.Size(30, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(15, 40),
                        scaledSize: new google.maps.Size(30, 40),
                      }}>
                      <div>
                        <h4>{o.text}</h4>
                        <a onClick={onClickShowAll}>{t("showAll")}</a>
                      </div>
                    </MarkerWithInfoWindow>
                  })}
                </GoogleMap>
              }
            </div>
          </div>
          <div className="column-7 teasers-container">
            {state.viewTypes.length > 1 && <div className="row">
              <div className="column-12">
                <div className="viewSwitch-container">
                  <a onClick={onSwitchView}>
                    {t("switchView")}
                    <i className="fa fa-th-large" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>}
            <div className="row">
              {searchResults.map(item => {
                return <div key={item.Id} className="column-4">
                  <div className="product-container">
                    <Link to={`/objectdetails/${item.Id}`}>
                      <figure className="product-image">
                        <div className="spacer"></div>
                        <Focuspoint
                          src={imgUrl(item.RentalObjectAttachment_firstImageId)}
                          imageW={756}
                          imageH={415}
                          focusX={0.0}
                          focusY={0.0}
                          reCalcOnWindowResize={true}
                        />
                      </figure>
                    </Link>
                    <div className="product-details">
                      <div className="product-name biggest">
                        <Link to={`/objectdetails/${item.Id}`}>{item.Name}</Link>
                      </div>
                      {!masterData.organization.FreeOfCharge && item.ResultPriceFrom > 0 && <div className="product-price">
                        <span className="from">{t("fromPrice")}</span>
                        <span className="amount">{item.Currency_Name} {item.ResultPriceFrom}</span>
                        <span className="duration">/ {item.PriceFromAllotmentTimeUnit_Name}</span>
                      </div>}
                    </div>
                    <div className="link-container">
                      <div className="link-details"><Link to={`/objectdetails/${item.Id}`}>{t("btnDetails")}<i className="fa fa-search" aria-hidden="true"></i></Link></div>
                      <div className="link-booking">{item.NotBookableOnline ? 
                        <a className="disabled">{t("btnBook")}<i className="fa fa-shopping-cart" aria-hidden="true"></i></a> : 
                        <Link to={`/wizard/book/${item.Id}`} onClick={(e) => onClickBooking(e, item.Id)}>{t("btnBook")}<i className="fa fa-shopping-cart" aria-hidden="true"></i></Link>
                      }</div>
                    </div>
                  </div>
                </div>
              })}
            </div>
            {canLoadMore && <div className="row load-more">
              <div className="column-12">
                <button onClick={loadMore}>{t("loadMore")} <i className="fa fa-refresh"></i></button>
              </div>
            </div>}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Search;


